import Routes from "@navigations/Routes";

/** Explore initial route helper; deeplink applies it only when large screen + one allowed product type (`getLinking`). */
export function getExploreNavigatorInitialRouteName(opts: {
  userIframeStatus: boolean | undefined;
  iFrameWithMultipleProducts: unknown;
  defaultScreenConfig?: { default_screen_name?: string } | null;
}): Routes {
  const { userIframeStatus, iFrameWithMultipleProducts, defaultScreenConfig } =
    opts;

  if (userIframeStatus && Boolean(iFrameWithMultipleProducts)) {
    return Routes.HomeScreen;
  }

  const name = defaultScreenConfig?.default_screen_name;
  if (name && (Object.values(Routes) as string[]).includes(String(name))) {
    return name as Routes;
  }

  return Routes.Explore;
}
